import { render, staticRenderFns } from "./activityGoodsForm.vue?vue&type=template&id=ff2866a8&scoped=true"
import script from "./activityGoodsForm.vue?vue&type=script&lang=js"
export * from "./activityGoodsForm.vue?vue&type=script&lang=js"
import style0 from "./activityGoodsForm.vue?vue&type=style&index=0&id=ff2866a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@7.0.0-bridge.0_@babel+core@7.29._1a562a7ff44e47125e24b47fdbb3ae4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2866a8",
  null
  
)

export default component.exports